/* global mockup:true */
/* eslint no-console: 0, no-unused-vars: 0, no-undef: 0, no-unused-expressions: 0 */
import Vue from 'vue'
import VueMoment from 'vue-moment'
import axios from '~/util/axios'
import Sentry from '~/util/sentry'
import Router from 'vue-router'
import Snackbard from 'snackbard'
import apolloClient from '~/util/apolloClient'
import vuetify from '~/util/vuetify'
import App from '~/components/evaultApp'
import icons from '~/util/icons'
import { store } from '../store/index'
import { VueMaskDirective } from 'v-mask'
import snEvaultService from '../services/snEvaultService'
import { ensureNcinoWebComponents } from '~/util/ncinoWebComponents'
import {
  snTabs,
  snCaptiveFlow,
  snGradientHeader,
  snTable,
  snTableColumnType,
  snAlert,
  snDatePicker,
  snExpansionPanel,
  snExpansionPanels,
  snDataItem,
  snSidePanel,
  snModal,
  snStatus,
  snFileInput,
  snAvatar,
  snIllustration,
  snSwitch,
  snChip,
  snCheckbox,
  snPdfViewer,
  snSelect,
  snAutocomplete,
  snCombobox,
  snRadio,
  snRadioGroup,
  snHeadlineCard,
  snLabel,
  snBtn,
  snBtnCard,
  snTooltip,
  snTextField,
  snTextarea,
  snPhotoUploader,
  snPassword,
  snDraggable
} from '@simplenexus/snui'
// eslint-disable-next-line import/no-unresolved
import '@simplenexus/snui/dist/assets/index.css'

import('~/assets/css/snIcons.css')

const ncinoWebComponentsReady = ensureNcinoWebComponents()

if (['development', 'staging'].includes(process.env.RAILS_ENV)) {
  Vue.config.devtools = true
}

Vue.component('snDatePicker', snDatePicker)
Vue.component('snTabs', snTabs)
Vue.component('snCaptiveFlow', snCaptiveFlow)
Vue.component('snExpansionPanel', snExpansionPanel)
Vue.component('snExpansionPanels', snExpansionPanels)
Vue.component('snGradientHeader', snGradientHeader)
Vue.component('snTable', snTable)
Vue.component('snTableColumnType', snTableColumnType)
Vue.component('snSidePanel', snSidePanel)
Vue.component('snAlert', snAlert)
Vue.component('snFileInput', snFileInput)
Vue.component('snDataItem', snDataItem)
Vue.component('snStatus', snStatus)
Vue.component('snModal', snModal)
Vue.component('snCheckbox', snCheckbox)
Vue.component('snChip', snChip)
Vue.component('snSwitch', snSwitch)
Vue.component('snAvatar', snAvatar)
Vue.component('snIllustration', snIllustration)
Vue.component('snPdfViewer', snPdfViewer)
Vue.component('snSelect', snSelect)
Vue.component('snAutocomplete', snAutocomplete)
Vue.component('snCombobox', snCombobox)
Vue.component('snRadio', snRadio)
Vue.component('snRadioGroup', snRadioGroup)
Vue.component('snHeadlineCard', snHeadlineCard)
Vue.component('snLabel', snLabel)
Vue.component('snBtn', snBtn)
Vue.component('snBtnCard', snBtnCard)
Vue.component('snTooltip', snTooltip)
Vue.component('snTextField', snTextField)
Vue.component('snTextarea', snTextarea)
Vue.component('snPhotoUploader', snPhotoUploader)
Vue.component('snPassword', snPassword)
Vue.component('snDraggable', snDraggable)

const { VueApollo, provider } = apolloClient()

Vue.use(Router)
Vue.use(VueApollo)
Vue.use(VueMoment)
Vue.use(Snackbard)
Vue.use(vuetify, {
  options: {
    customProperties: true
  },
  icons: icons
})

Vue.directive('mask', VueMaskDirective)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: 'transactions'
    },
    {
      path: '/support_tools',
      name: 'SupportTools',
      meta: { title: 'Support tools' },
      component: () =>
        import('~/components/supportTools')
    },
    {
      path: '/mers_tools',
      name: 'MersTools',
      meta: { title: 'MERS Tools' },
      component: () =>
        import('~/components/mersTools')
    },
    {
      path: '/integrations',
      name: 'API Integrations',
      meta: { title: 'API Integrations' },
      component: () =>
        import('~/components/tables/apiClients/apiClientsTable')
    },
    {
      path: '/transactions',
      name: 'Transactions',
      meta: { title: 'Transactions' },
      component: () =>
        import('~/components/transactions')
    },
    {
      path: '/transactions/:guid',
      name: 'TransactionDetails',
      meta: { title: 'Transaction details' },
      component: () =>
        import('~/components/transactionDetails')
    },
    {
      path: '/data_dashboard',
      name: 'Data Dashboard',
      meta: { title: 'Data Dashboard' },
      component: () =>
        import('~/components/dataDashboard.vue')
    },
    {
      path: '/enotes',
      name: 'EnoteInventory',
      meta: { title: 'eNote inventory' },
      component: () =>
        import('~/components/enoteInventory')
    },
    {
      path: '/enotes/:guid',
      name: 'Enote',
      meta: { title: 'eNote' },
      component: () =>
        import('~/components/enote')
    },
    {
      path: '/consent/:guid',
      name: 'Consent',
      meta: { title: 'Consent' },
      component: () =>
        import('~/components/consent')
    },
    {
      path: '/login',
      name: 'Login',
      meta: { title: 'Login' },
      component: () =>
        import('~/components/login')
    },
    {
      path: '/companies',
      name: 'Companies',
      meta: { title: 'Companies' },
      component: () =>
        import('~/components/companies')
    },
    {
      path: '/companies/:guid',
      name: 'Company Details',
      meta: { title: 'Company Details' },
      component: () =>
        import('~/components/companyDetails')
    },
    {
      path: '/company_settings',
      name: 'Settings',
      meta: { title: 'Settings' },
      component: () =>
        import('~/components/companySettings')
    },
    {
      path: '/electronic_records',
      name: 'Electronic Records',
      meta: { title: 'Electronic records' },
      component: () =>
        import('~/components/electronicRecords')
    },
    {
      path: '/reports',
      name: 'Reports',
      meta: { title: 'Reports' },
      component: () =>
        import('~/components/reports')
    },
    {
      path: '/reports/:guid',
      name: 'Report Details',
      meta: { title: 'Report Details' },
      component: () =>
        import('~/components/reports_v2/reportDetails')
    },
    {
      path: '/electronic_records/:guid',
      name: 'Doc Details',
      meta: { title: 'Doc Details' },
      component: () =>
        import('~/components/electronicRecordsDetails.vue')
    },
    {
      path: '/no_access/:entity',
      name: 'No Access',
      meta: { title: 'No Access' },
      component: () =>
        import('~/components/noAccess')
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'Page Not Found',
      meta: { title: 'Page not found' },
      component: () =>
        import('~/components/pageNotFound')
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  const user = store.getters.user
  if (user == null || user.loading === true) {
    next()
  } else {
    const hasMersOrgId = !!store.getters.mersOrgId
    const canAccess = snEvaultService.canAccess(user, to.name, hasMersOrgId)
    if (!canAccess) {
      next({ path: snEvaultService.getDefaultPage(user, hasMersOrgId) })
    } else {
      next()
    }
  }
})

router.afterEach((to, from) => {
  Vue.nextTick(() => {
    document.title = `eVault - ${to.meta.title || 'SimpleNexus'}`
    window.scrollTo(0, 0)
  })
})

Vue.prototype.$sentry = Sentry([{ key: 'pack', value: 'Evault' }])
Vue.prototype.$axios = axios

// Mount once the ngc-* elements are defined. @ncino/web-components is loaded
// through a dynamic import, so until it resolves every ngc-* is an unknown
// inline element: no shadow root, no styles, and its light DOM rendered as
// plain text - which briefly exposes the contents of closed ngc-modals (the
// My Profile dialog among them) and leaves the side nav blank, since
// ngc-list-item renders its label from an attribute rather than a slot.
// finally() rather than then() so a failed chunk still mounts the app instead
// of leaving a blank page.
ncinoWebComponentsReady.finally(() => {
  // eslint-disable-next-line no-unused-vars
  const app = new Vue({
    router,
    store,
    el: '#evault',
    apolloProvider: provider,
    render: h => h(App),
    vuetify
  })
})
